import { useConfig } from '../../../../context';
export const useFlightIconFallbackSrc = () => {
    const { global: { companyInfo: { iataCode } } } = useConfig();
    return `https://cdn.websky.aero/content/frontend/images/airline-images/${iataCode}.png`;
};
